import { useEffect, useState } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { IconFilterSvg } from "../../common/utils/icons";
import GenericResearchQueryResults from "../../components/Rules/GenericResearchQueryResults";
import { useAppTranslation } from "../../hooks/useAppTranslation";
import GenericResearchQueryIssueResults from "../../components/Rules/GenericResearchQueryIssueResults";

interface IRootCauseAnalysisProps {
  heading: string;
  dashboardData: any;
}

const GenericRootCauseAnalysis = ({
  heading,
  dashboardData,
}: IRootCauseAnalysisProps) => {
  const [rootCauseAnalysisData, setRootCauseAnalysisData] = useState<any>([]);
  const { t } = useAppTranslation();
  const [resourceKeys, setResourceKeys] = useState<any>([]);
  const [isFilterHide, setIsFilterHide] = useState(true);
  //for pagination default values and states
  const defaultPage = process.env.REACT_APP_DEFAULT_PAGE;
  const defaultPageSize = process.env.REACT_APP_DEFAULT_PAGE_SIZE;
  const [pageN, setPageN] = useState<number>(
    defaultPage ? parseInt(defaultPage) : 1
  );
  const [pageS, setPageS] = useState<number>(
    defaultPageSize ? parseInt(defaultPageSize) : 25
  );
  const [isResearchQueryLoading, setIsResearchQueryLoading] =
    useState<boolean>(false);

  useEffect(() => {
    if (!dashboardData) return;
    if (dashboardData?.research_query_results) {
      setRootCauseAnalysisData(dashboardData.research_query_results);
    }

    if (dashboardData?.resource_keys) {
      setResourceKeys(dashboardData.resource_keys);
    }
  }, [dashboardData]);
  const handleFilterBox = () => {
    setIsFilterHide(!isFilterHide);
  };

  return (
    <>
      <Box className="mui-tabs-title mt-6">
        <Tooltip
          title={`${
            isFilterHide
              ? t("genericRootCauseAnalysis.showFilters")
              : t("genericRootCauseAnalysis.hideFilters")
          } `}
          placement="top"
        >
          <IconButton className="" onClick={() => handleFilterBox()}>
            <IconFilterSvg />
          </IconButton>
        </Tooltip>
        {heading}
      </Box>
      {dashboardData?.is_detailed_execution_data_available ? (
        <GenericResearchQueryResults
          rootCauseAnalysisData={rootCauseAnalysisData}
          isLoading={isResearchQueryLoading}
          isFilterHide={isFilterHide}
          resourceKeys={resourceKeys}
          dashboardData={dashboardData}
          pageN={pageN}
          setPageN={setPageN}
          pageS={pageS}
          setPageS={setPageS}
          totalPages={0}
        />
      ) : (
        <GenericResearchQueryIssueResults
          dashboardData={dashboardData}
          setIsResearchQueryLoading={setIsResearchQueryLoading}
          resourceKeys={resourceKeys}
          isFilterHide={isFilterHide}
          isResearchQueryLoading={isResearchQueryLoading}
        />
      )}
    </>
  );
};

export default GenericRootCauseAnalysis;
